export default "__VITE_ASSET__B7Zzad5k__"